module.exports = __webpack_public_path__ + "static/media/profile_icon.fabdad57.svg";